// Front/src/pages/Main.js

import React from 'react';
import '../style/Main.css';
import { Helmet } from 'react-helmet-async';  // Import Helmet


const MainPage = () => {
  return (
    <div className="main-page">

      {/* ✅ Set the page title back to "Shekel Technet" */}
      <Helmet>
        <title>Shekel Technet</title>
      </Helmet>

      <h1>Welcome to Technet</h1>
      <p>
        Complete your Scale Reports easily.
      </p>
    </div>
  );
};

export default MainPage;
